<div
  class="px-8 py-4 flex items-center border-b"
  [ngClass]="{
    'bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-900 text-red-600 dark:text-red-400': type === 'danger',
    'bg-yellow-50 dark:bg-yellow-950 border-yellow-200 dark:border-yellow-900 text-yellow-700 dark:text-yellow-400': type === 'warning',
    'bg-blue-50 dark:bg-blue-950 border-blue-200 dark:border-blue-900 text-blue-400 dark:text-blue-300': type === 'info',
    'animate-fadeintop': animation
  }"
>
  <div class="flex-grow text-sm font-normal">
    <ng-content></ng-content>
  </div>
  @if (id && closeable) {
    <div class="w-8 h-8 flex items-center justify-center">
      <a
        href="#"
        (click)="$event.preventDefault(); close()"
      >
        <lucide-angular [name]="x"></lucide-angular>
      </a>
    </div>
  }
</div>
